module.exports = __webpack_public_path__ + "99bef93863d5f8a7d50d528d2710713c.svg";